import React from "react";
import { Select, MenuItem, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
	select: {
		background: "white",
		color: theme.palette.text.primary,
		marginRight: theme.spacing(2),
		borderRadius: 4,
		minWidth: 160,
		boxShadow: theme.shadows[1],
		paddingLeft: theme.spacing(1),
		"&:before": {
			borderColor: theme.palette.divider,
		},
		"&:after": {
			borderColor: theme.palette.primary.main,
		},
		"& .MuiSelect-icon": {
			color: theme.palette.text.primary,
		},
	},
	menuItem: {
		color: theme.palette.text.primary,
	},
}));

type Site = {
	readonly code: string;
	readonly url: string;
	readonly label: string;
};

type SiteSwitcherProps = {
	currentSiteCode: string;
	availableSites: readonly Site[];
};

function SiteSwitcher({ currentSiteCode, availableSites }: SiteSwitcherProps) {
	const classes = useStyles();

	const handleSiteChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const selectedSite = availableSites.find(
			(site) => site.code === event.target.value,
		);
		if (selectedSite) {
			window.location.href = selectedSite.url;
		}
	};

	const currentSite = availableSites.find(
		(site) => site.code === currentSiteCode,
	);

	return (
		<Select
			value={currentSiteCode}
			onChange={handleSiteChange}
			className={classes.select}
			disableUnderline
			displayEmpty
			renderValue={() => (currentSite ? currentSite.label : "Select Site")}
		>
			{availableSites.map((site) => (
				<MenuItem
					key={site.code}
					value={site.code}
					className={classes.menuItem}
				>
					{site.label}
				</MenuItem>
			))}
		</Select>
	);
}

export { SiteSwitcher };
